import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      @media screen and ", " {\n        grid-template-columns: repeat(", ", 1fr);\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      @media screen and ", " {\n        grid-template-columns: repeat(", ", 1fr);\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      grid-template-columns: repeat(", ", 1fr);\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 0 ", ";\n  grid-template-columns: 1fr;\n\n  ", "\n\n  ", "\n    \n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { mediaQueryTabletMax, mediaQueryMobileMax } from '@scp/ui-shared/theme/responsive';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
export var GridResponsiveWrapper = styled.div(_templateObject(), baselineToPx(7), function (props) {
  return props.desktopColCount && css(_templateObject2(), props.desktopColCount);
}, function (props) {
  return props.tabletColCount && css(_templateObject3(), mediaQueryTabletMax, props.tabletColCount);
}, function (props) {
  return props.mobileColCount && css(_templateObject4(), mediaQueryMobileMax, props.mobileColCount);
});